module.exports = __webpack_public_path__ + "static/img/btn_dkjj_right_pre.7827e867.png";